/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */

import type { DataResponse_FeedbackResponse_ } from "../models/DataResponse_FeedbackResponse_";
import type { FeedbackRequest } from "../models/FeedbackRequest";
import type { MessageOnlyResponse } from "../models/MessageOnlyResponse";
import type { CancelablePromise } from "../core/CancelablePromise";
import { OpenAPI } from "../core/OpenAPI";
import { request as __request } from "../core/request";
export class FeedbackService {
  /**
   * Update Feedback
   * Updates the feedback for a user.
   * Currently supports plan_setup feedback.
   * @param xUserId
   * @param requestBody
   * @returns MessageOnlyResponse Successful Response
   * @throws ApiError
   */
  public static updateFeedbackApiV1FeedbackPut(
    xUserId: string,
    requestBody: FeedbackRequest,
  ): CancelablePromise<MessageOnlyResponse> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/api/v1/feedback",
      headers: {
        "x-user-id": xUserId,
      },
      body: requestBody,
      mediaType: "application/json",
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Get Feedback
   * Returns the feedback for a user.
   * @param xUserId
   * @returns DataResponse_FeedbackResponse_ Successful Response
   * @throws ApiError
   */
  public static getFeedbackApiV1FeedbackGet(
    xUserId: string,
  ): CancelablePromise<DataResponse_FeedbackResponse_> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v1/feedback",
      headers: {
        "x-user-id": xUserId,
      },
      errors: {
        422: `Validation Error`,
      },
    });
  }
}
